import { render, staticRenderFns } from "./OpportuniteView.vue?vue&type=template&id=33a4780d&scoped=true&"
import script from "./OpportuniteView.vue?vue&type=script&lang=js&"
export * from "./OpportuniteView.vue?vue&type=script&lang=js&"
import style0 from "./OpportuniteView.vue?vue&type=style&index=0&id=33a4780d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a4780d",
  null
  
)

export default component.exports